import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SendTestimonyApiData } from "../temoignages/schemas/schema";
export const useTestimonyPatch = (clubSlug, testimonyId) => {
  const $ = _c(8);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== testimonyId) {
    t0 = async data => {
      const response = await fetch(`/api/club-testimonies?id=${testimonyId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...data
        })
      });
      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }
      const dataResponse = await response.json();
      return dataResponse;
    };
    $[0] = testimonyId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== clubSlug || $[3] !== queryClient) {
    t1 = _data => {
      queryClient.invalidateQueries({
        queryKey: ["club", clubSlug, "testimonies"]
      });
    };
    $[2] = clubSlug;
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
};